module.exports = __webpack_public_path__ + "static/media/Artboard16.fa3b3b66.png";